var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#72BC44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5556 24.6406C46.2819 24.47 45.9331 24.4531 45.6444 24.5994L39.5 27.6706V25.4375C39.5 23.8869 38.2381 22.625 36.6875 22.625H19.8125C18.2619 22.625 17 23.8869 17 25.4375V38.5625C17 40.1131 18.2619 41.375 19.8125 41.375H36.6875C38.2381 41.375 39.5 40.1131 39.5 38.5625V36.3294L45.6425 39.4006C45.9313 39.545 46.2763 39.5319 46.5538 39.3594C46.8313 39.1888 47 38.8869 47 38.5625V25.4375C47 25.1131 46.8312 24.8112 46.5556 24.6406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/Video-on.ebb19683980bcefd4ce2318c2869bb40.svg";
export { ForwardRef as ReactComponent };